import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors duration-200">
            <i className="ri-home-4-line"></i>
            <span className="sr-only">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}